import Model from './Model'

export default class Automation extends Model {
    resource() {
        return 'automation';
    }


    // updated the automation
    updateAutomation(id, data) {
        return this.request({
            url: `${this.resource()}/${id}`,
            method: 'put',
            data: {
                name: data.name,
                pre_condition: data.pre_condition,
                post_condition: data.post_condition,
                status: data.status,
            }
        });
    }

    // updated the status of the automation
    updateAutomationStatue(id, status) {
        return this.request({
            url: `${this.resource()}/${id}`,
            method: 'put',
            data: {
                status
            }
        });
    }
}
